// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload_alert[data-v-f016d952]{background-color:#0b0e3c}.upload_alert[data-v-f016d952],.upload_error[data-v-f016d952]{border:0;position:relative;padding:20px 15px;line-height:20px;margin-bottom:20px;z-index:99999!important;color:#fff;border-radius:3px;box-shadow:0 12px 20px -10px rgb(153 153 153/28%),0 4px 20px 0 rgb(0 0 0/12%),0 7px 8px -5px rgb(153 153 153/20%)}.upload_error[data-v-f016d952]{background-color:#e31854}", ""]);
// Exports
module.exports = exports;
